"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = Skeleton;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("cn");
function Skeleton({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("div", { "data-slot": "skeleton", className: (0, cn_1.cn)('animate-pulse rounded-md bg-accent', className), ...props });
}
